/**
 * Perfil da instância (build-time) — CRM Rocket.
 * Default: rocket (Comercial, Financeiro, Portal e Configuração).
 * Override: VITE_INSTANCE_PROFILE=agrada
 */

export type InstanceProfile = 'agrada' | 'rocket'

export const INSTANCE_PROFILE: InstanceProfile =
  import.meta.env.VITE_INSTANCE_PROFILE === 'agrada' ? 'agrada' : 'rocket'

export const isRocketInstance = INSTANCE_PROFILE === 'rocket'

/** Módulos Conecta habilitados por perfil. */
export const ROCKET_ENABLED_MODULES = ['comercial', 'financeiro', 'portal_pj', 'admin'] as const

/** Prefixo de rotas front bloqueadas no perfil Rocket. */
export const ROCKET_BLOCKED_PATH_PREFIXES = [
  '/cs',
  '/gestores',
  '/security',
  '/rocket-search',
  '/proposal-studio',
  /** Sem operação BDR no momento — painel Leads & BDR desativado. */
  '/bdr-panel',
] as const

export function isPathAllowedForInstance(pathname: string, profile: InstanceProfile = INSTANCE_PROFILE): boolean {
  if (profile !== 'rocket') return true
  const path = pathname.split('?')[0]
  return !ROCKET_BLOCKED_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  )
}

export function getInstanceDisplayName(profile: InstanceProfile = INSTANCE_PROFILE): string {
  return profile === 'rocket' ? 'Rocket Search CRM' : 'Conecta'
}

/** Logo da tela de login (fallback quando não há logo no tema). Login é layout claro. */
export function getLoginFallbackLogo(profile: InstanceProfile = INSTANCE_PROFILE): string {
  return profile === 'rocket' ? '/logo-rocket-light.svg' : '/logo-sidebar-light.png'
}

/** Logos Rocket por tema: escrita branca (dark) / escrita preta (light). */
export function getRocketThemeLogo(mode: 'dark' | 'light'): string {
  return mode === 'dark' ? '/logo-rocket-dark.png' : '/logo-rocket-light.svg'
}
